import { render, staticRenderFns } from "./Journeylist.vue?vue&type=template&id=3c5f2e12&scoped=true&"
import script from "./Journeylist.vue?vue&type=script&lang=js&"
export * from "./Journeylist.vue?vue&type=script&lang=js&"
import style0 from "./Journeylist.vue?vue&type=style&index=0&id=3c5f2e12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5f2e12",
  null
  
)

export default component.exports